import { createReducer, on } from '@ngrx/store';

import * as MoonshotActions from './moonshot.actions';

export const moonshotFeatureKey = 'moonshotFeature';
export interface MoonshotState {
  moonshotEnabled: boolean;
  userPatientId: string | null;
}

export const initialMoonshotState: MoonshotState = {
  moonshotEnabled: false,
  userPatientId: null,
};

export const moonshotReducer = createReducer(
  initialMoonshotState,
  on(MoonshotActions.setMoonshotEnabled, (state, { enabled }) => ({
    ...state,
    moonshotEnabled: enabled,
  })),
  on(MoonshotActions.setUserPatientId, (state, { patientId }) => ({
    ...state,
    userPatientId: patientId,
  })),
  on(MoonshotActions.resetMoonshotState, () => ({
    ...initialMoonshotState,
  }))
);
